import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import H2 from 'UIComponents/elements/headings/H2';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import HomeSection from './HomeSection';
import HomeSectionInner from './HomeSectionInner';
const GridItem = styled((_ref) => {
  let {
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return /*#__PURE__*/_jsx(UIGridItem, Object.assign({}, rest, {
    className: classNames(className, 'p-x-6')
  }));
}).withConfig({
  displayName: "MediaSection__GridItem",
  componentId: "sywbxg-0"
})(["order:1;"]);
const MediaGridItem = styled((_ref2) => {
  let rest = _objectWithoutPropertiesLoose(_ref2, ["orientation"]);

  return /*#__PURE__*/_jsx(GridItem, Object.assign({}, rest));
}).withConfig({
  displayName: "MediaSection__MediaGridItem",
  componentId: "sywbxg-1"
})(["order:", ";@media (max-width:", "){order:2;margin-top:40px;}"], props => props.orientation === 'media-left' ? 0 : 2, GRID_BREAKPOINT_MEDIUM);
export default function MediaSection(_ref3) {
  let {
    button,
    className,
    color,
    description,
    media,
    orientation,
    title
  } = _ref3,
      rest = _objectWithoutPropertiesLoose(_ref3, ["button", "className", "color", "description", "media", "orientation", "title"]);

  return /*#__PURE__*/_jsx(HomeSection, Object.assign({}, rest, {
    className: className,
    color: color,
    children: /*#__PURE__*/_jsx(HomeSectionInner, {
      children: /*#__PURE__*/_jsxs(UIGrid, {
        children: [/*#__PURE__*/_jsxs(GridItem, {
          className: "align-self-center display-block",
          size: {
            sm: 12,
            md: 5
          },
          children: [/*#__PURE__*/_jsx(H2, {
            className: "is--heading-1",
            children: title
          }), /*#__PURE__*/_jsx("p", {
            children: description
          }), button]
        }), /*#__PURE__*/_jsx(MediaGridItem, {
          orientation: orientation,
          size: {
            sm: 12,
            md: 7
          },
          children: media
        })]
      })
    })
  }));
}